export { default } from './ShaojiangWindowOpenLink';
